module.exports = __webpack_public_path__ + "media/frontend/base/typo/fonts/NeoSansPro-Medium-print-792b4e17fb438597df63db3a1212e792.ttf";